(()=>{var t,e={425:()=>{$(document).ready((function(){$(document).on("click",".cart-gift-product-check",(function(t){var e=$(t.target).parent().parent().find(".cart-gift-notes");$(this).is(":checked")?(e.show(),$(this).val(1)):(e.hide(),$(this).val(0),$(this).removeAttr("checked"))})),$(document).on("click","#cart_glass_check",(function(t){$(this).is(":checked")?$(this).val(1):($(this).val(0),$(this).removeAttr("checked"))}))})),setTimeout((function(){$.get("/browsing_context_suggestions.json",(function(t){$("body").attr("data-country",t.detected_values.country.handle);var e=t.detected_values.country.handle;"DE"!=e?"AUT"==e?($(".product-shipping-time-message .product-ship-time-icon").show(),$(".product-shipping-time-message .product-ship-time-text-aut").show()):($(".product-shipping-time-message .product-ship-time-icon").show(),$(".product-shipping-time-message .product-ship-time-text-rest").show()):($(".product-shipping-time-message .product-ship-time-icon").show(),$(".product-shipping-time-message .product-ship-time-text-de").show())}))}),500)},314:()=>{}},i={};function s(t){var o=i[t];if(void 0!==o)return o.exports;var r=i[t]={exports:{}};return e[t](r,r.exports,s),r.exports}s.m=e,t=[],s.O=(e,i,o,r)=>{if(!i){var c=1/0;for(a=0;a<t.length;a++){for(var[i,o,r]=t[a],n=!0,p=0;p<i.length;p++)(!1&r||c>=r)&&Object.keys(s.O).every((t=>s.O[t](i[p])))?i.splice(p--,1):(n=!1,r<c&&(c=r));if(n){t.splice(a--,1);var h=o();void 0!==h&&(e=h)}}return e}r=r||0;for(var a=t.length;a>0&&t[a-1][2]>r;a--)t[a]=t[a-1];t[a]=[i,o,r]},s.o=(t,e)=>Object.prototype.hasOwnProperty.call(t,e),(()=>{var t={725:0,888:0};s.O.j=e=>0===t[e];var e=(e,i)=>{var o,r,[c,n,p]=i,h=0;if(c.some((e=>0!==t[e]))){for(o in n)s.o(n,o)&&(s.m[o]=n[o]);if(p)var a=p(s)}for(e&&e(i);h<c.length;h++)r=c[h],s.o(t,r)&&t[r]&&t[r][0](),t[r]=0;return s.O(a)},i=self.webpackChunkspiritofliebs=self.webpackChunkspiritofliebs||[];i.forEach(e.bind(null,0)),i.push=e.bind(null,i.push.bind(i))})(),s.O(void 0,[888],(()=>s(425)));var o=s.O(void 0,[888],(()=>s(314)));o=s.O(o)})();

$(".product-slideshow__details").click((function(t){t.stopImmediatePropagation()})),$(".product-slideshow__action").click((function(t){$(".product-slideshow__details").toggleClass("tooltip-active")})),$(document).on("click",(function(t){$(t.target).closest(".product-slideshow__details").length||$(".product-slideshow__details").removeClass("tooltip-active")}));

/* Added by Hardik */
$(document).on('click', 'button.Popover__Value', function(){
  var data_val = $(this).attr('data-value');
  if($('.Select option[data-title="' + $(this).attr('data-value') + '"]').is(":disabled")){
    $('.ProductForm .ads_back_instock').show();
    $('.ProductForm .product-shipping-time-message').hide();
  } else {
    $('.ProductForm .product-shipping-time-message').show();
    $('.ProductForm .ads_back_instock').hide();
  }
  var $select = $(this).closest('form').find('select[name="id"]');
  $select.find('option[data-title="'+data_val+'"]').prop('selected', true);
  $select.trigger('change'); // This ensures the selection is properly updated
  $('.ProductForm__SelectedValue').text(data_val);
  $(this).closest('.Popover').attr('aria-hidden', true);
  $('.product__OffScreen_overlay').toggleClass('active');
});

// $(document).ready(function(){
//   if($('.CartItemWrapper.giftWrapper').length != 0){
//     $('.cart-gift-wrapper-packaging #cart-gift-wrapper').prop('checked', true);
//   }
// });

$(document).on('click', '.cart-gift-wrapper-packaging #cart-gift-wrapper1', function(){
  console.log("test wrapper_product");
  var wrapper_id = $(this).attr('wrapper_product'); 
  if($(this).is(':checked')){ 
     console.log("checked=", wrapper_id);

     $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: wrapper_id
        },
        dataType: 'json', 
        success: function (data) { 
          // $('#CartCount span:first').text(data.quantity);
          console.log(data.quantity);
        } 
     });
  } else {
    jQuery.post('/cart/change.js', { quantity: 0, id: wrapper_id });
  }
});

// STICKY ADD TO CART
function debounce(fn, wait = 500) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const stickyProductFrom = () => {
  const windowScroll = window.scrollY;
  const scrollTarget = document.querySelector('.ProductMain');
  const scrollTargetOffset = scrollTarget.getBoundingClientRect().top + scrollTarget.offsetHeight + windowScroll;

  if (windowScroll > scrollTargetOffset) {
    document.querySelector('.ProductStickyCart').classList.add('is-visible');
  } else {
    document.querySelector('.ProductStickyCart').classList.remove('is-visible');
  }
}

const productFormVariantChanged = (productForm) => {
  console.log('working');
  const productJSON = JSON.parse(productForm.querySelector('[data-product-json]').innerHTML);
  const productVariants = productJSON.product.variants;
  
  const selectedVariantId = productForm.querySelector('[name="id"]').value;
  const selectedVariant = productVariants.find( variant => (variant.id == selectedVariantId));

  selectedVariant.options.forEach( (optionValue, optionIndex)  => {
    const index = optionIndex + 1;

    document.querySelectorAll(`.OptionSelector [data-option-position="${index}"], .ProductForm__Option [data-option-position="${index}"]`).forEach( swatchElement => {
      const swatchElementValue = (swatchElement.type == 'radio') ? swatchElement.value : swatchElement.dataset.value;
      const swatchElementChecked = (swatchElement.checked || swatchElement.classList.contains('is-selected')) ? true : false;

      if (swatchElementValue == optionValue && swatchElementChecked == false) {
        swatchElement.click();
      }
    });
  });
}

if (document.getElementById('ProductStickyCart')) {
  stickyProductFrom();
  window.addEventListener('scroll', stickyProductFrom);

  document.querySelectorAll('.ProductForm').forEach( productForm => {
    productForm.addEventListener('change', debounce(() => productFormVariantChanged(productForm)));
  });
}

$('.ProductForm__Variants .ProductForm__Item').click(function(){
  var aria_controls = $(this).attr('aria-controls');
  $('#'+aria_controls).attr('aria-hidden', false);
  $('.product__OffScreen_overlay').toggleClass('active');
});
$('.Product__OffScreen .Popover__Close').click(function(){
  $(this).closest('.Popover').attr('aria-hidden', true);
  $('.product__OffScreen_overlay').toggleClass('active');
});
$('.product__OffScreen_overlay').click(function(){
  $(this).closest('.Product__OffScreen').find('.Popover').attr('aria-hidden', true);
  $(this).toggleClass('active');
});


//------------------ Line Item Gift Add ------------------------
let typingTimer;
let doneTypingInterval = 500; // 0.5 seconds after user stops typing

function updateCartProperties(line_item_key, isChecked, message = "") {
    disableCheckoutButton();

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let item = cart.items.find(i => i.key === line_item_key);

            if (item) {
                let properties = { "als_Geschenk_verpacken": isChecked };

                // Add message only if checked and message is not empty
                if (isChecked && message.trim() !== "") {
                    properties["als_Geschenk_verpacken_message"] = message;
                }

                // Update cart item properties
                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: line_item_key,
                        properties: properties
                    })
                })
                .then(response => response.json())
                .then(() => {
                    if (isChecked) {
                        return handleFreeGift(); // Add free gift
                    } else {
                        return checkAndRemoveFreeGift(); // Remove if no gift wrapping exists
                    }
                })
                .finally(enableCheckoutButton);
            } else {
                enableCheckoutButton();
            }
        })
        .catch(() => enableCheckoutButton());
}

// Disable checkout button during updates
function disableCheckoutButton() {
    $('.cart-drawer__footer button[name="checkout"]').attr('disabled', true);
}

// Enable checkout button after updates
function enableCheckoutButton() {
    $('.cart-drawer__footer button[name="checkout"]').removeAttr('disabled');
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
    }));
}

// Handle checkbox change
$(document).on('change', '[data-cart-glass-packaging]', function () {
    let line_item_key = $(this).attr('item_key');
    let isChecked = $(this).is(':checked');
    let message = $('.gift-item-cart-note[data-item-product-id="' + $(this).attr('data-item-product-id') + '"]').val() || "";

    updateCartProperties(line_item_key, isChecked, message);
});

// Handle message input (delayed update to avoid multiple requests)
$(document).on('input', '.gift-item-cart-note', function () {
    clearTimeout(typingTimer);
    let textarea = $(this);
    let line_item_key = textarea.attr('item_key');
    let message = textarea.val();
    let isChecked = $('[data-cart-glass-packaging][data-item-product-id="' + textarea.attr('data-item-product-id') + '"]').is(':checked');

    typingTimer = setTimeout(function () {
        updateCartProperties(line_item_key, isChecked, message);
    }, doneTypingInterval);
});

// Check and add free gift if needed
function handleFreeGift() {
    return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let free_item = parseInt($('.cart-drawer__items').attr('free-gift-item'));
            let freeGiftExists = cart.items.some(i => i.id === free_item);

            if (!freeGiftExists) {
                return addProductWithProperties(free_item, { "isgift": true }, 1);
            }
        })
        .catch(console.error);
}

// Check if free gift should be removed
function checkAndRemoveFreeGift() {
    return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let free_item = parseInt($('.cart-drawer__items').attr('free-gift-item'));
            let freeGiftItem = cart.items.find(i => i.id === free_item);
            let anyGiftWrappedItem = cart.items.some(i => i.properties && i.properties["als_Geschenk_verpacken"] === true);

            if (freeGiftItem && !anyGiftWrappedItem) {
                return removeCartItem(freeGiftItem.key);
            }
        })
        .catch(console.error);
}

// Function to remove an item from cart
function removeCartItem(lineItemKey) {
    return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: lineItemKey,
            quantity: 0
        })
    }).then(response => response.json())
      .then(data => console.log('Item removed:', data))
      .catch(console.error);
}

// Function to add product with properties
function addProductWithProperties(variantId, properties, quantity) {
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: properties
        })
    }).then(response => response.json())
      .then(data => console.log('Item added with new properties:', data))
      .catch(console.error);
}

// Cart checkbox change
$(document).on('change', '[data-cart-note]', function () {
    let noteText = $(this).is(':checked') ? 'Auf SOL-Glasschatulle verzichten: True' : '';

    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteText })
    })
    .then(response => response.json())
    .then(cart => console.log('Order note updated:', cart))
    .catch(error => console.error('Error updating note:', error));
});













